<!-- 临时退货弹窗 -->
<template>
   <el-dialog title="临时退货" :visible.sync="dialogVisible" width="800px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @opened="handleOpened" @close="handleClose">
      <div class="temp-return-dialog">
         <!-- 会员卡选择区域 -->
         <div class="member-section">
            <div class="member-input-row">
               <div class="member-input-section">
                  <label class="member-label">会员卡号:</label>
                  <el-input v-model="returnForm.memberCardNo" placeholder="请输入会员卡号或扫描会员卡" clearable @keyup.enter.native="searchMember" @blur="searchMember" style="width: 280px;">
                     <el-button slot="append" icon="el-icon-search" @click="searchMember"></el-button>
                  </el-input>
               </div>
               <div class="member-info-section" v-if="memberInfo.memberName">
                  <label class="member-label">会员信息:</label>
                  <div class="member-info-content">
                     <span class="member-name">{{ memberInfo.memberName }}</span>
                     <span class="member-phone" v-if="memberInfo.memberPhone">（{{ memberInfo.memberPhone }}）</span>
                  </div>
               </div>
            </div>
         </div>

         <!-- 商品选择区域 -->
         <div class="product-section">
            <div class="section-header">
               <span class="section-title">退货商品</span>
               <el-button type="primary" size="small" @click="openProductSelection">
                  <i class="el-icon-plus"></i> 选择商品
               </el-button>
            </div>

            <!-- 退货商品列表 -->
            <div class="return-products-list">
               <el-table :data="returnProducts" border size="mini" max-height="300" empty-text="暂无退货商品">
                  <el-table-column prop="bgmCode" label="商品编码" width="120"></el-table-column>
                  <el-table-column prop="bgmName" label="商品名称" min-width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="spec" label="规格" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="batchno" label="批号" width="100"></el-table-column>
                  <el-table-column prop="retailPrice" label="单价" width="80" align="right">
                     <template slot-scope="scope">
                        ¥{{ scope.row.retailPrice.toFixed(2) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="returnQuantity" label="退货数量" width="100" align="center">
                     <template slot-scope="scope">
                        <el-input v-model="scope.row.returnQuantity" type="number" :min="1" :max="scope.row.maxReturnQuantity" size="mini" @change="calculateTotal"></el-input>
                     </template>
                  </el-table-column>
                  <el-table-column prop="returnAmount" label="退货金额" width="100" align="right">
                     <template slot-scope="scope">
                        ¥{{ ((memberInfo.memberId ? scope.row.memberPrice : scope.row.retailPrice) * scope.row.returnQuantity).toFixed(2) }}
                     </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80" align="center">
                     <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="removeProduct(scope.$index)" style="color: #f56c6c;">
                           删除
                        </el-button>
                     </template>
                  </el-table-column>
               </el-table>
            </div>

            <!-- 退货汇总 -->
            <div class="return-summary" v-if="returnProducts.length > 0">
               <div class="summary-item">
                  <span>退货商品数量：</span>
                  <span class="summary-value">{{ totalQuantity }} 件</span>
               </div>
               <div class="summary-item">
                  <span>退货总金额：</span>
                  <span class="summary-value total-amount">¥{{ totalAmount.toFixed(2) }}</span>
               </div>
            </div>
         </div>

      </div>

      <div slot="footer" class="dialog-footer">
         <el-button @click="handleCancel">取消</el-button>
         <el-button type="primary" @click="handleConfirm" :disabled="!canConfirm">确认退货</el-button>
      </div>

      <!-- 商品选择弹窗 -->
      <el-dialog title="选择退货商品" :visible.sync="productSelectionVisible" width="1000px" :close-on-click-modal="false" append-to-body>
         <div class="product-selection">
            <!-- 搜索区域 -->
            <div class="search-section">
               <el-form :inline="true" size="small" @submit.native.prevent="searchProducts">
                  <el-form-item label="商品名称:">
                     <el-input v-model="productSearch.bgmName" placeholder="请输入商品名称" clearable @keyup.enter.native="searchProducts" style="width: 200px;"></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="searchProducts">查询</el-button>
                     <el-button @click="resetSearch">重置</el-button>
                  </el-form-item>
               </el-form>
            </div>

            <!-- 商品列表 -->
            <div class="products-table">
               <el-table :data="availableProducts" border size="mini" max-height="400" @selection-change="handleProductSelection">
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="bgmCode" label="商品编码" width="120"></el-table-column>
                  <el-table-column prop="bgmName" label="商品名称" min-width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="spec" label="规格" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="batchno" label="批号" width="100"></el-table-column>
                  <el-table-column prop="retailPrice" label="零售价" width="80" align="right">
                     <template slot-scope="scope">
                        ¥{{ scope.row.retailPrice.toFixed(2) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="memberPrice" label="会员价" width="80" align="right">
                     <template slot-scope="scope">
                        ¥{{ scope.row.memberPrice.toFixed(2) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="stock" label="库存" width="80" align="right"></el-table-column>
               </el-table>
            </div>
         </div>

         <div slot="footer">
            <el-button @click="productSelectionVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmProductSelection" :disabled="selectedProducts.length === 0">
               确认选择（{{ selectedProducts.length }}）
            </el-button>
         </div>
      </el-dialog>

      <!-- 会员选择弹窗 -->
      <el-dialog title="选择会员" :visible.sync="memberSelectionVisible" width="800px" :close-on-click-modal="false" append-to-body>
         <div class="member-selection">
            <!-- 搜索区域 -->
            <div class="search-section">
               <el-form :inline="true" size="small" @submit.native.prevent="getMemberList">
                  <el-form-item label="搜索关键词:">
                     <el-input v-model="memberSelectSearch" placeholder="请输入手机号、姓名或身份证号" clearable @keyup.enter.native="getMemberList" style="width: 250px;"></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="getMemberList">查询</el-button>
                     <el-button @click="resetMemberSearch">重置</el-button>
                  </el-form-item>
               </el-form>
            </div>

            <!-- 会员列表 -->
            <div class="members-table">
               <el-table :data="memberSelectList" border size="mini" max-height="400" highlight-current-row @current-change="handleMemberSelection" @row-dblclick="handleMemberDoubleClick">
                  <el-table-column prop="cardNo" label="会员卡号" width="120"></el-table-column>
                  <el-table-column prop="name" label="会员姓名" width="100"></el-table-column>
                  <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
                  <el-table-column prop="cardType" label="卡类型" width="100"></el-table-column>
                  <el-table-column prop="points" label="积分" width="80" align="right"></el-table-column>
                  <el-table-column prop="storedBalance" label="储值余额" width="100" align="right">
                     <template slot-scope="scope">
                        ¥{{ scope.row.storedBalance.toFixed(2) }}
                     </template>
                  </el-table-column>
                  <el-table-column prop="registerStore" label="注册门店" min-width="120" show-overflow-tooltip></el-table-column>
               </el-table>
            </div>
         </div>

         <div slot="footer">
            <el-button @click="memberSelectionVisible = false">取消</el-button>
            <el-button type="primary" @click="confirmMemberSelection" :disabled="!selectedMember">
               确认选择
            </el-button>
         </div>
      </el-dialog>
   </el-dialog>
</template>

<script>
export default {
   name: 'TempReturnDialog',
   props: {
      visible: {
         type: Boolean,
         default: false
      },
      curDate: {
         type: Number,
         default: ''
      },
      curTime: {
         type: Number,
         default: ''
      },
      day: {
         type: Number,
         default: ''
      },
      week: {
         type: Number,
         default: ''
      },
      storeId: {
         type: Number,
         default: ''
      }
   },
   data() {
      return {
         dialogVisible: false,
         productSelectionVisible: false,
         memberSelectionVisible: false,
         returnForm: {
            memberCardNo: '',
            remark: ''
         },
         memberInfo: {
            memberName: '',
            memberPhone: '',
            memberId: '',
            memIdcard: '',
         },
         returnProducts: [],
         availableProducts: [],
         selectedProducts: [],
         productSearch: {
            bgmName: '',
 
         },
         totalQuantity: 0,
         totalAmount: 0,
         // 会员查询相关
         memberSelectSearch: '',
         memberSelectList: [],
         selectedMemberIndex: -1,
         selectedMember: null
      }
   },
   computed: {
      canConfirm() {
         return this.returnProducts.length > 0;
      }
   },
   watch: {
      visible(val) {
         this.dialogVisible = val;
      },
      dialogVisible(val) {
         this.$emit('update:visible', val);
      }
   },
   methods: {
      handleOpened() {
         this.$emit('opened');
         // 弹窗打开时的初始化操作
         this.resetForm();
      },

      handleClose() {
         this.$emit('close');
      },

      handleCancel() {
         this.dialogVisible = false;
      },
      async getMemberList() {
         try {
            const searchKey = this.memberSelectSearch.trim();
            // 检查搜索关键词是否为空
            if (!searchKey) {
               this.memberSelectList = [];
               this.selectedMemberIndex = -1;
               return;
            }
            const res = await this.$http.memberDeskQueryMem({
               // memIdcard: searchKey, // 身份证号搜索
               // memName: searchKey, // 姓名搜索
               keyWord: searchKey, // 手机号搜索
               // ormId: 1,     
            });
            if (res && res.status === 200 && res.result && res.result.list) {
               this.memberSelectList = res.result.list.map(item => ({
                  cardNo: item.cardCode || '',
                  cardType: item.capName || '',
                  name: item.memName || '',
                  phone: item.memPhone || '',
                  idCard: item.memIdcard || '',
                  points: item.pointBalance || 0,
                  registerStore: item.storeName || '',
                  pointBalance: item.pointBalance || 0,
                  storedBalance: item.storedBalance || 0,
                  memId: item.memId || '' // 添加会员ID
               }));
               console.log(this.memberSelectList, 'this.memberSelectList');
               // 重置选择状态
               this.selectedMemberIndex = -1;
               this.selectedMember = null;
            }
         } catch (error) {
            console.error('获取会员列表失败:', error);
            this.$message.error('获取会员列表失败');
         }
      },

      // 选择会员
      onMemberSelect(member) {
         this.memberInfo = {
            memberName: member.name,
            memberPhone: member.phone,
            memberId: member.memId,
            memIdcard: member.idCard,
         };
         this.returnForm.memberCardNo = member.cardNo;
         console.log('选择会员:', member);
      },
      handleConfirm() {
         if (this.returnProducts.length === 0) {
            this.$message.warning('请先添加要退货的商品');
            return;
         }
         
         console.log(this.returnProducts, 'returnProducts');
         
         // 将退货清单中的商品转换为购物车格式
         const returnItems = this.returnProducts.map(item => ({
            ...item,
            price: this.memberInfo.memberId ? item.memberPrice : item.retailPrice,
            changePrice: this.memberInfo.memberId ? item.memberPrice : item.retailPrice,
            quantity: -item.returnQuantity, // 负数表示退货
            psprice: this.memberInfo.memberId ? item.memberPrice : item.retailPrice,
            isReturn: true, // 标记为退货商品
            isTempReturn: true, // 标记为临时退货
            returnReason: '临时退货', // 退货原因
            originalQuantity: item.returnQuantity, // 保存原始退货数量（正数）
            amount:this.memberInfo.memberId ? item.memberPrice * (-item.returnQuantity) : item.retailPrice * (-item.returnQuantity),
            actualPrice: this.memberInfo.memberId ? item.memberPrice : item.retailPrice,
            memPrice: item.memberPrice,
            retailPrice:this.memberInfo.memberId ? item.memberPrice : item.retailPrice,
            prodate: item.prodate,
            expdate: item.expdate,
         }));

         // 触发确认事件，传递退货商品列表和会员信息
         this.$emit('confirm', {
            returnProducts: returnItems,
            memberInfo: this.memberInfo,
            returnForm: this.returnForm,
            totalQuantity: this.totalQuantity,
            totalAmount: this.totalAmount
         });

         // 关闭弹窗
         this.dialogVisible = false;

         this.$message.success(`已添加 ${returnItems.length} 种退货商品到购物车`);
      },

      resetForm() {
         this.returnForm = {
            memberCardNo: '',
            remark: ''
         };
         this.memberInfo = {
            memberName: '',
            memberPhone: '',
            memberId: '',
            memIdcard: '',
         };
         this.returnProducts = [];
         this.totalQuantity = 0;
         this.totalAmount = 0;
         // 重置会员查询相关数据
         this.memberSelectSearch = '';
         this.memberSelectList = [];
         this.selectedMemberIndex = -1;
         this.selectedMember = null;
      },

      // 搜索会员
      async searchMember() {
         if (!this.returnForm.memberCardNo.trim()) {
            this.memberInfo = {
               memberName: '',
               memberPhone: '',
               memberId: '',
               memIdcard: '',
            };
            return;
         }

         try {
            // 使用会员卡号作为搜索关键词
            this.memberSelectSearch = this.returnForm.memberCardNo;
            await this.getMemberList();

            // 根据查询结果数量决定处理方式
            if (this.memberSelectList.length === 0) {
               this.$message.warning('未找到该会员信息');
               this.memberInfo = {
                  memberName: '',
                  memberPhone: '',
                  memberId: '',
                  memIdcard: '',
               };
            } else if (this.memberSelectList.length === 1) {
               // 只有一条结果，直接选择
               this.onMemberSelect(this.memberSelectList[0]);
            } else {
               // 多条结果，打开弹窗选择
               this.memberSelectionVisible = true;

            }
         } catch (error) {
            this.$message.error('会员信息获取失败');
            this.memberInfo = {
               memberName: '',
               memberPhone: '',
               memberId: '',
               memIdcard: '',
            };
         }
      },

      // 打开会员选择弹窗
      openMemberSelectDialog() {
         this.memberSelectionVisible = true;
         // 如果会员卡号输入框有内容，使用它作为搜索关键词
         if (this.returnForm.memberCardNo.trim()) {
            this.memberSelectSearch = this.returnForm.memberCardNo;
            this.getMemberList();
         } else {
            this.memberSelectSearch = '';
            this.memberSelectList = [];
         }
         this.selectedMember = null;
      },

      // 重置会员搜索
      resetMemberSearch() {
         this.memberSelectSearch = '';
         this.memberSelectList = [];
         this.selectedMember = null;
      },

      // 处理会员选择
      handleMemberSelection(member) {
         this.selectedMember = member;
      },

      // 处理会员双击选择
      handleMemberDoubleClick(member) {
         this.selectedMember = member;
         this.confirmMemberSelection();
      },

      // 确认会员选择
      confirmMemberSelection() {
         if (this.selectedMember) {
            this.onMemberSelect(this.selectedMember);
            this.memberSelectionVisible = false;
            this.$message.success('会员选择成功');
         }
      },

      // 打开商品选择弹窗
      openProductSelection() {
         this.productSelectionVisible = true;
         // 清空之前的搜索结果
         this.availableProducts = [];
      },

      // 搜索商品
      async searchProducts() {
         // 检查搜索条件
         if (!this.productSearch.bgmName || !this.productSearch.bgmName.trim()) {
            this.$message.warning('请输入商品名称');
            return;
         }

         try {
            // 这里调用商品查询接口
            const response = await this.$http.priceGroupGetZtBgm({
              bgmName: this.productSearch.bgmName.trim(),
              curDate: this.curDate,
              curTime: this.curTime,
              day: this.day,
              storeId: this.storeId,
              week: this.week
            });
            // 处理接口返回的数据，转换为表格需要的格式
            if (response && response.result && Array.isArray(response.result)) {
               this.availableProducts = response.result.map(item => ({
                  bgmId: item.bgmId,
                  bgmCode: item.bgmCode,
                  bgmName: item.bgmName,
                  spec: item.spec,
                  batchno: item.batchno,
                  retailPrice: item.price || 0, // 使用price作为零售价
                  memberPrice: item.memberPrice || 0, // 会员价
                  stock: item.num || 0, // 使用num作为库存
                  manufacturer: item.manufacturer,
                  barcode: item.barcode,
                  prodate: item.prodate,
                  expidate: item.expidate,
                  bgsId: item.bgsId
               }));
            } else {
               this.availableProducts = [];
            }

         } catch (error) {
            this.$message.error('商品查询失败');
            this.availableProducts = [];
         }
      },

      // 重置搜索
      resetSearch() {
         this.productSearch = {
            bgmName: '',
         };
         this.searchProducts();
      },

      // 处理商品选择
      handleProductSelection(selection) {
         this.selectedProducts = selection;
      },

      // 确认商品选择
      confirmProductSelection() {
         this.selectedProducts.forEach(product => {
            // 检查是否已经添加过（使用bgsId作为唯一标识，因为同一商品不同批次有不同的bgsId）
            const existingIndex = this.returnProducts.findIndex(p => p.bgsId === product.bgsId);

            if (existingIndex === -1) {
               // 添加新商品
               this.returnProducts.push({
                  ...product,
                  returnQuantity: 1,
                  maxReturnQuantity: product.stock
               });
            } else {
               this.$message.warning(`商品"${product.bgmName}"(批号:${product.batchno})已存在，请直接修改数量`);
            }
         });

         this.calculateTotal();
         this.productSelectionVisible = false;
         this.selectedProducts = [];
      },

      // 移除商品
      removeProduct(index) {
         this.returnProducts.splice(index, 1);
         this.calculateTotal();
      },

      // 计算总计
      calculateTotal() {
         this.totalQuantity = this.returnProducts.reduce((sum, product) => sum + product.returnQuantity, 0);
         this.totalAmount = this.returnProducts.reduce((sum, product) => {
            const price = this.memberInfo.memberId ? product.memberPrice : product.retailPrice;
            return sum + (price * product.returnQuantity);
         }, 0);
      }
   }
}
</script>

<style scoped>
.temp-return-dialog {
   padding: 10px 0;
}

.member-section {
   margin-bottom: 20px;
   padding: 15px;
   background-color: #f8f9fa;
   border-radius: 4px;
}

.member-input-row {
   display: flex;
   align-items: flex-start;
   gap: 30px;
   flex-wrap: wrap;
}

.member-input-section {
   display: flex;
   align-items: center;
   gap: 10px;
   flex: 1;
   min-width: 400px;
}

.member-info-section {
   display: flex;
   align-items: center;
   gap: 10px;
   flex: 1;
   min-width: 200px;
}

.member-label {
   font-weight: 500;
   color: #606266;
   white-space: nowrap;
   min-width: 80px;
}

.member-info-content {
   display: flex;
   align-items: center;
}

.member-name {
   font-weight: bold;
   color: #409eff;
}

.member-phone {
   color: #909399;
   margin-left: 10px;
}

.product-section {
   margin-bottom: 20px;
}

.section-header {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 10px;
   padding-bottom: 10px;
   border-bottom: 1px solid #ebeef5;
}

.section-title {
   font-weight: bold;
   font-size: 14px;
}

.return-products-list {
   margin-bottom: 15px;
}

.return-summary {
   display: flex;
   justify-content: flex-end;
   gap: 30px;
   padding: 10px;
   background-color: #f8f9fa;
   border-radius: 4px;
}

.summary-item {
   display: flex;
   align-items: center;
   gap: 5px;
}

.summary-value {
   font-weight: bold;
}

.total-amount {
   color: #f56c6c;
   font-size: 16px;
}

.reason-section {
   padding: 15px;
   background-color: #f8f9fa;
   border-radius: 4px;
}

.product-selection {
   padding: 10px 0;
}

.search-section {
   margin-bottom: 15px;
   padding: 15px;
   background-color: #f8f9fa;
   border-radius: 4px;
}

.products-table {
   margin-bottom: 10px;
}

.dialog-footer {
   text-align: right;
}

.member-selection {
   padding: 10px 0;
}

.members-table {
   margin-bottom: 10px;
}
</style>
